module.exports = __webpack_public_path__ + "static/media/user-minus.ad9632ca.svg";